import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';

export class NavMenu extends Component {
  displayName = NavMenu.name

  render() {
    return (
      <Navbar inverse fixedTop fluid collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to={'/'}>RightMessage Admin Panel</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <LinkContainer to={'/customer'} className={window.location.pathname === '/' ? 'active' : ''}>
              <NavItem>
                Customers
              </NavItem>
            </LinkContainer>
          </Nav>
          <Nav>
            <LinkContainer to={'/organization'}>
              <NavItem>
                Organizations
              </NavItem>
            </LinkContainer>
          </Nav>
          <Nav>
            <LinkContainer to={'/notification-type'}>
              <NavItem>
                Notification Types
              </NavItem>
            </LinkContainer>
          </Nav>
          <Nav>
            <LinkContainer to={'/reports'}>
              <NavItem>
                Reports
              </NavItem>
            </LinkContainer>
          </Nav>
          <Nav>
            <LinkContainer to={'/create-account'}>
              <NavItem>
                Create Account
              </NavItem>
            </LinkContainer>
          </Nav>
          <Nav>
            <LinkContainer to={'/admin'}>
              <NavItem>
                Admin
              </NavItem>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}
